import styled from 'styled-components'
import useTranslation from '../../hooks/useTranslation'

const PillBar = styled.div`
    display: flex;
    background: ${({ theme }) => theme.form.border};
    border-radius: 999px;
    padding: 3px;
    gap: 3px;
    margin: 0 0.5rem 0.75rem;
`

const PillButton = styled.button`
    flex: 1;
    padding: 0.45rem 0.75rem;
    font-size: 0.85rem;
    font-weight: 600;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    background: ${({ $active, theme }) => $active ? theme.btn.primary : 'transparent'};
    color: ${({ $active, theme }) => $active ? theme.btn.font : theme.font.label};

    &:hover {
        color: ${({ $active, theme }) => $active ? theme.btn.font : theme.font.color};
    }
`


const Content = styled.div`
    display: ${({ $active }) => $active ? 'block' : 'none'};
`

const ProcessTabs = ({ tabs, activeTab, onTabChange }) => {
    const { t } = useTranslation()

    return (
        <>
            <PillBar>
                {tabs.map(tab => (
                    <PillButton
                        key={tab.key}
                        type="button"
                        $active={activeTab === tab.key}
                        data-testid={tab.testId}
                        onClick={() => onTabChange(tab.key)}
                    >
                        {t(tab.label)}
                    </PillButton>
                ))}
            </PillBar>

            {tabs.map(tab => (
                <Content key={tab.key} $active={activeTab === tab.key}>
                    {tab.content}
                </Content>
            ))}
        </>
    )
}

export default ProcessTabs
